/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
import {html} from 'htm/preact';
import {isAPIError /*:: , type APIError */} from '../api.js';

function renderAPIErrorView({errorObject} /*: APIError */) {
  const title =
    errorObject.status && errorObject.title
      ? `${errorObject.status} - ${errorObject.title}`
      : errorObject.status || errorObject.title || null;
  return html`
    <article>
      ${title && html`<h2>${title}</h2>`}
      ${errorObject.detail && html`<p>${errorObject.detail}</p>`}
    </article>
  `;
}
export function ErrorView({error} /*: {+error: Error} */) /*: React$Node */ {
  console.error(error);
  if (isAPIError(error)) {
    return error.errors.map(renderAPIErrorView);
  }
  return html`<article><p>${error.toString()}</p></article>`;
}
